import Vue from 'vue'
import operationPermission from './operationPermission'

Vue.directive('operationPermission', operationPermission)



// WEBPACK FOOTER //
// ./src/directive/index.js